export const createColorChart = (primary, secondary) => [primary, secondary];
export const isNeutral = type => type === 'neutral';
const isInverted = type => type === 'inverted';
const getColorByIndex = (colorChart, index) => colorChart[index % 2];
const getInvertedColorByIndex = (colorChart, index) => getColorByIndex(colorChart, index + 1);
export const resolveColorByIconIndexAndType = (index, type, colorChart) => isInverted(type) ? getInvertedColorByIndex(colorChart, index) : getColorByIndex(colorChart, index);
//# sourceMappingURL=color.js.map